import { render, staticRenderFns } from "./NotificationSingle.vue?vue&type=template&id=59585e71&"
import script from "./NotificationSingle.vue?vue&type=script&lang=js&"
export * from "./NotificationSingle.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSingle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NotificationSingle.vue"
export default component.exports